export default "__VITE_ASSET__0486fbbc__"